"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

type ConsentValue = "all" | "essential";

const STORAGE_KEY = "cookie-consent";

export function CookieConsent() {
  const [consent, setConsent] = useState<ConsentValue | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "all" || stored === "essential") {
      setConsent(stored);
    }
    setMounted(true);
  }, []);

  // Don't render until we've checked localStorage to prevent flash
  if (!mounted || consent !== null) {
    return null;
  }

  const handleConsent = (value: ConsentValue) => {
    window.localStorage.setItem(STORAGE_KEY, value);
    setConsent(value);
  };

  return (
    <div className="fixed inset-x-4 bottom-4 z-[90] rounded-2xl border border-border bg-background/95 p-4 shadow-lg backdrop-blur sm:inset-x-auto sm:right-6 sm:w-[440px]">
      <div className="space-y-3 text-sm text-muted-foreground">
        <div className="text-base font-semibold text-foreground">We use cookies</div>
        <p>
          We use essential cookies to run the platform and optional cookies to understand usage and improve the
          experience. Learn more in our{" "}
          <Link href="/cookie-policy" className="text-primary hover:underline">
            Cookie Policy
          </Link>
          .
        </p>
      </div>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={() => handleConsent("essential")}
          className="rounded-md border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-foreground/5"
        >
          Decline non-essential
        </button>
        <button
          type="button"
          onClick={() => handleConsent("all")}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Accept all
        </button>
      </div>
    </div>
  );
}
